"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthLayout = void 0;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const react_i18next_1 = require("react-i18next");
const CenterContent_1 = require("../CenterContent/CenterContent");
const Card_1 = require("../Card/Card");
const CardTitle_1 = require("../CardTitle/CardTitle");
exports.AuthLayout = (props) => {
    const { context, children, links, message, titleBlock, subTitle } = props;
    const { t } = react_i18next_1.useTranslation(context);
    return (react_1.default.createElement(CenterContent_1.CenterContent, null,
        react_1.default.createElement("div", { className: "col-lg-6 AuthLayout", id: context },
            titleBlock,
            react_1.default.createElement(Card_1.Card, null,
                react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(CardTitle_1.CardTitle, null, t('title')),
                    react_1.default.createElement("p", { className: "text-muted" }, subTitle || t('subTitle')),
                    children,
                    links.map((l) => (react_1.default.createElement(react_router_dom_1.Link, { to: l.to, key: l.to, id: `${context}-${l.id}` }, l.text))),
                    react_1.default.createElement("div", { className: "text-center" }, message))))));
};
//# sourceMappingURL=AuthLayout.js.map